import React from "react";
import { Switch, Route } from "react-router-dom";
import Assignments from "./Assignments.js";

export default function AssignmentView() {
  return (
    <div>
      <React.Fragment>
        <Switch>
          <Route
            exact
            path="/assignments"
            render={(props) => <Assignments {...props} />}
          />
        </Switch>
      </React.Fragment>
    </div>
  );
}

